import { render, staticRenderFns } from "./DetailsInformationFrund.vue?vue&type=template&id=983ea774&"
import script from "./DetailsInformationFrund.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationFrund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports